export class RetentionPolicy {
    disabled: boolean;
    minimumBackupAgeToKeep: string;
}